<template>
    <div>
        <li :class="itemClass">
            <router-link :to="uri" :style="padding">
                        <span role="button" :class="caretIcon" @click="toggle"></span>
                {{page.title}}
            </router-link>
        </li>
        <div v-show="expanded" class="parent-dropdown">
            <page-menu-item :page="child"
                            :level="parseInt(level) + 1"
                            v-for="child in page.children" :key="child.slug"
                            :parentSlug="parentSlug"
                            :actual-uri="actualUri"/>
        </div>
    </div>
</template>

<script>
  import { LOCAL_STORAGE_KEYS } from '../../../constants/LocalStorage';
  import LocalStorage from '../../../utils/localStorage';

  export default {
    name: 'ParentPageMenuItem',
    props: ['page', 'parentSlug', 'actualUri', 'level', 'padding'],
    components: {
      'PageMenuItem': () => import('./PageMenuItem.vue')
    },
    data() {
      const menuItems = this.getUserPreferences();
      const uri = `/page/${this.parentSlug}/${this.page.slug}`; // computed is not available during instantiation data
      return {
        expanded: menuItems[uri] ? menuItems[uri] : false
      }
    },
    computed: {
      itemClass() {
        return 'list-group-item parent ' + (this.actualUri === this.uri ? 'active' : '');
      },
      uri() {
        return `/page/${this.parentSlug}/${this.page.slug}`;
      },
      caretIcon() {
        return 'fa menu-icon caret-icon ' + (this.expanded ? 'fa-caret-down' : 'fa-caret-right')
      }
    },
    methods: {
      getUserPreferences() {
        const key = LOCAL_STORAGE_KEYS.PAGES_MENU;
        return LocalStorage.get(key) || {};
      },
      updateUserPreferences() {
        const key = LOCAL_STORAGE_KEYS.PAGES_MENU;
        const menuItems = this.getUserPreferences();
        menuItems[this.uri] = this.expanded;
        LocalStorage.store(menuItems, key);
      },
      toggle(e) {
        e.stopPropagation();
        e.preventDefault();
        this.expanded = !this.expanded;
        this.updateUserPreferences();
      }
    }
  };
</script>

<style scoped>
    .collapse li a  {
        padding-left: 30px !important;
    }
</style>
